import * as yup from 'yup';

export const TemplateValidationSchema = yup.object({
  title: yup.string().required('Please fill template title!'),
});

export const CreateChecklistValidationSchema = yup.object({
  name: yup.string().required('Please fill template title!'),
});
